// Every stylesheet, in cascade order, before any code that could pull one in (#1169).
import './app/styles';

// Ugly fix to get @webpack/svgr working with preact & typescript
import * as Preact from 'preact';
(window as any)['React'] = Preact;

import { enableFlaskFlashes } from '@brainfocus/web/flash';
import { render } from 'preact';
import { App } from '@brainfocus/web/app';
import { announceSessionIdentity } from '@brainfocus/web/services/session_identity';
import { startShowEdfAnnotationsSync } from '@brainfocus/web/utils/edf_annotations_visibility_preference';
import { installVisibleWindowHooksScheduler } from '@brainfocus/web/shared/platform/visible_window_scheduler';

enableFlaskFlashes();

// Hooks flush their effects on the window the user can see: with a detached
// viewer in front the main window is hidden and its frames/timers are throttled,
// which left detached traces seconds behind a page step (RC2 QA V70).
installVisibleWindowHooksScheduler();

// Tell the other tabs and windows which user this page was rendered for (#871).
// A login is a form POST followed by a redirect, so this page load IS the moment
// the identity changed; every window rendered for someone else marks itself stale.
// Before the app renders, so a window that is already stale shows it on first paint.
announceSessionIdentity();

// Keep "Show EDF annotations" in step with the other open tabs and windows (#976).
startShowEdfAnnotationsSync();

const appContainer = document.querySelector('bf-app');
if (appContainer) {
    render(<App />, appContainer);
}
